import {BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React from 'react';
import routes from "./routes";

/** Authentication **/
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/authentication/PrivateRoute';
import AdminRoute from "./components/authentication/AdminRoute";

/** CSS **/
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/shards-dashboards.min.css";
import "./assets/custom.css"


const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Switch>
          {routes.map((route, index) => {
            if (route.path === '/' || route.path === '/login' || route.path === '/forgot-password') {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={props => {
                    return (
                      <route.layout {...props}>
                        <route.component {...props} />
                      </route.layout>
                    )
                  }
                  }
                />
              );
            } else if (route.path === '/admin' || route.path === '/update-users' || route.path === '/admin-reports') {
              return (
                <AdminRoute
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={props => {
                    return (
                      <route.layout {...props}>
                        <route.component {...props} />
                      </route.layout>
                    );
                  }}
                />
              );
            }
            else {
              return (
                <PrivateRoute
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={props => {
                    return (
                      <route.layout {...props}>
                        <route.component {...props} />
                      </route.layout>
                    );
                  }}
                />

              );
            }
          })}
        </Switch>
      </AuthProvider>
    </Router>);
}
export default App;